var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('avatar',{attrs:{"initials":_vm.initials,"value":_vm.user.email,"smaller":_vm.smaller}})
}
var staticRenderFns = []

export { render, staticRenderFns }